import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import Transfers from './pages/Transfers';
import Exchange from './pages/Exchange';
import Debts from './pages/Debts';
import Treasury from './pages/Treasury';
import Reports from './pages/Reports';
import Accounts from './pages/Accounts';
import ClientManage from './pages/ClientManage';
import ClientLogin from './pages/ClientLogin';
import ClientDashboard from './pages/ClientDashboard';
import SuperAdmin from './pages/SuperAdmin';
import './index.css';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

const ClientPrivateRoute = ({ children }) => {
  const token = localStorage.getItem('client_token');
  return token ? children : <Navigate to="/client/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* الرئيسي */}
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/customers" element={<PrivateRoute><Customers /></PrivateRoute>} />
        <Route path="/transfers" element={<PrivateRoute><Transfers /></PrivateRoute>} />
        <Route path="/exchange" element={<PrivateRoute><Exchange /></PrivateRoute>} />
        <Route path="/debts" element={<PrivateRoute><Debts /></PrivateRoute>} />
        <Route path="/treasury" element={<PrivateRoute><Treasury /></PrivateRoute>} />
        <Route path="/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
        <Route path="/accounts" element={<PrivateRoute><Accounts /></PrivateRoute>} />
        <Route path="/clients" element={<PrivateRoute><ClientManage /></PrivateRoute>} />

        {/* الفروع */}
        <Route path="/client/login" element={<ClientLogin />} />
        <Route path="/client/dashboard" element={<ClientPrivateRoute><ClientDashboard /></ClientPrivateRoute>} />

        {/* Super Admin */}
        <Route path="/super-admin" element={<SuperAdmin />} />
      </Routes>
    </Router>
  );
}

export default App;